import type { DeckWithStats } from '../../types/domain'
import type { GTask } from '../../lib/tasks/tasks-service'
import { useI18n } from '../../lib/i18n/i18n-store'
import { DrawerReadouts } from '../deck/DrawerReadouts'

interface StudyBlockProps {
  deck: DeckWithStats
  task?: GTask | undefined
  onStudy: () => void
  onClick: () => void
}

export function StudyBlock({ deck, task, onStudy, onClick }: StudyBlockProps) {
  const { t } = useI18n()
  const due = (deck.stats?.due_today ?? 0) + (deck.stats?.overdue_cards ?? 0)
  const newCards = deck.stats?.new_cards ?? 0

  // Extract suggested time from task notes
  const time = task?.notes
    ? (task.notes.match(/Hora sugerida: (\d{2}:\d{2})/)?.[1] ?? null)
    : null

  return (
    // A real <button>, not a div with onClick: the card opens the deck, and a
    // keyboard user could not reach that destination at all before — only the
    // nested play button was focusable, and it goes somewhere else.
    // .drawer: a skin draws it as a drawer front in the deck's colour, and the
    // play key as its pull, which then says what it does (.silk).
    <div
      className="study-block drawer"
      style={deck.instance.deck_color ? { '--deck-color': deck.instance.deck_color } as React.CSSProperties : undefined}
    >
      <button className="study-block-open" onClick={onClick}>
        <span className="study-block-name">{deck.instance.deck_name}</span>
        <span className="study-block-meta">
          {time && <span className="study-block-time">🕐 {time}</span>}
          {due > 0 && (
            <span className="chip study-block-badge study-block-badge--due">
              {t(due === 1 ? 'deck.pending' : 'deck.pendingPlural', { count: due })}
            </span>
          )}
          {newCards > 0 && (
            <span className="chip study-block-badge study-block-badge--new">
              {t('deck.newCards', { count: newCards })}
            </span>
          )}
        </span>
      </button>
      <DrawerReadouts stats={deck.stats} />
      <button
        className="btn btn--soft study-block-btn"
        title={t('dashboard.reviewNow')}
        aria-label={`${t('dashboard.reviewNow')}: ${deck.instance.deck_name}`}
        onClick={onStudy}
      >
        ▶<span className="silk">{t('drawer.pull')}</span>
      </button>
    </div>
  )
}
